import React from 'react';
import Header from '../components/Header';

class Home extends React.PureComponent {
  render() {
    return (
      <Header />
    );
  }
}
export default Home;
